import 'owl.carousel';

export function sliders()
{
	let sliders = $('.slider');

	sliders.each(function()
	{
		let isSlider = $(this).attr('data-gallery');
		let nav = [
			'<svg viewBox="0 0 11.5 21.5"><use xlink:href="#icon-larr" /></svg>',
			'<svg viewBox="0 0 11.5 21.5"><use xlink:href="#icon-rarr" /></svg>',
		];
		
		let options = {
			items: 1,
			nav: isSlider,
			mouseDrag: isSlider,
			touchDrag: isSlider,
			dots: false,
			navText: nav,
			loop: true,
		};

		$(this).owlCarousel(options);
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js